import React from 'react';
import { useTranslation } from 'react-i18next';
import { UsersIcon } from '@guryou/html-components';
import { useCurrentUser } from '@guryou/redux';
import { fetchChannelsWhereUserIsMember, removeNotificationChannel } from 'firebase/firebaseFunctions';
import { Icon } from '../../components/shared';

const SidebarChannel = ({
  chatActive,
  setActiveChat,
  setLoadingMessage,
  currentTab,
  setCurrentTab,
  channels,
  providers,
  changeProvider,
  currentProvider,
  hasUnreadChats,
  hasUnreadChannels,
}) => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();

  const handleChangeActiveChannel = async channel => {
    try {
      setLoadingMessage(true);
      const unsubscribe = await fetchChannelsWhereUserIsMember(channel?.id);
      await removeNotificationChannel(+user?.id, channel?.id);
      setLoadingMessage(false);
      setActiveChat({ ...channel, id: unsubscribe.id });
    } catch (error) {}
  };

  return (
    <div class="w-full h-full border-r border-gray-200 bg-white relative flex flex-col">
      {/* Header with back button */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50">
        <button
          onClick={() => changeProvider(null)}
          className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
        >
          <Icon name="arrow-left" size="sm" />
          <div className="flex items-center gap-2">
            <img
              className="w-8 h-8 rounded-full ring-2 ring-gray-200"
              src={currentProvider?.images?.[0]?.small || '/icons/icon-512x512.png'}
              alt=""
            />
            <span className="text-sm font-semibold text-gray-900">{currentProvider?.name}</span>
          </div>
        </button>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 bg-white">
        <button
          onClick={() => setCurrentTab('chat')}
          className={`flex-1 flex items-center justify-center gap-2 p-3 text-sm font-semibold transition-all relative ${
            currentTab === 'chat' ? 'text-[var(--feel-primary)]' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="relative">
            <Icon name="chat" size="sm" />
            {hasUnreadChats && currentTab !== 'chat' && (
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border border-white"></span>
            )}
          </div>
          {t('CHAT.chat')}
          {currentTab === 'chat' && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[var(--feel-primary)]"></span>}
        </button>
        <button
          onClick={() => setCurrentTab('channel')}
          className={`flex-1 flex items-center justify-center gap-2 p-3 text-sm font-semibold transition-all relative ${
            currentTab === 'channel' ? 'text-[var(--feel-primary)]' : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="relative">
            <Icon name="hashtag" size="sm" />
            {hasUnreadChannels && currentTab !== 'channel' && (
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border border-white"></span>
            )}
          </div>
          {t('CHAT.channel')}
          {currentTab === 'channel' && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[var(--feel-primary)]"></span>}
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {channels?.length === 0 && (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="w-16 h-16 mb-4 rounded-full bg-gray-100 flex items-center justify-center">
              <UsersIcon className="text-gray-400" fontSize="large" />
            </div>
            <p className="text-sm font-medium text-gray-500">{t('CHAT.noChannelsAvailable')}</p>
            <p className="text-xs text-gray-400 mt-1">{t('CHAT.channelsWillAppear')}</p>
          </div>
        )}
        {channels?.map(chat => {
          return (
            <button
              key={chat?.id}
              class={`${
                chatActive?.id === chat?.id ? 'bg-gray-100 border-gray-200 border' : ''
              } flex items-center justify-between gap-3 p-3 w-full rounded-lg hover:bg-gray-100 transition-colors border border-transparent hover:border-gray-200`}
              onClick={() => handleChangeActiveChannel(chat)}
            >
              <div class="flex items-center gap-3 flex-1 min-w-0">
                <div className="relative flex items-center justify-center w-10 h-10 rounded-full bg-[var(--feel-primary)]/10">
                  <UsersIcon className="text-[var(--feel-primary)]" />
                  {chat?.unreadChats && (
                    <span class="absolute -top-1 -right-1 w-3 h-3 bg-[var(--feel-primary)] border-2 border-white rounded-full"></span>
                  )}
                </div>
                <div class="font-medium flex-1 min-w-0">
                  <div class="text-sm font-semibold text-gray-900 text-left truncate">{chat?.name}</div>
                  <div class="text-xs text-gray-500 text-left truncate">Criado por: {chat?.creator?.name}</div>
                </div>
              </div>
              <Icon name="chevron-right" className="text-gray-400" size="md" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarChannel;
